console.log("init Proteus treatments -- 1.02")

if(window.location.href.indexOf("/products/4lb-collagen-peptides-bag") > -1){}
// 4lb PDP -- hide WEEKS options
/* 
1mo: 1241153671
2mo: 1241186439
3mo: 1241219207
4wk: 3022454919
6wk: 3022487687
8wk: 3022520455
12wk: 3022553223
24wk: 3022585991
*/
waitForElement('skio-plan-picker').then(plan_picker => {

    waitUntil(() => {

        return !!(
            plan_picker.shadowRoot &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown') &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options.length > 0
        );

    }).then(() => {

        let selling_plans_options = plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options;
        for(let i = 0; i < selling_plans_options.length; i++){
            if(selling_plans_options[i].value == "3022454919" || 
            selling_plans_options[i].value == "3022487687" || 
            selling_plans_options[i].value == "3022520455" || 
            selling_plans_options[i].value == "3022553223" || 
            selling_plans_options[i].value == "3022585991"){
                selling_plans_options[i].hidden = true;
            } 
        }

    }).catch();

}).catch();

if(window.sessionStorage.getItem("GLW-02") == "v1"){

  console.log("init [GLW-02]v1")

      /*

  10oz - Quantity 2 // every 4 weeks
  16oz - Quantity 2 // every 6 weeks
  32oz Quantity 1 // every 6 weeks
  4lbs Quantity 1 // every 12 weeks 
  4lbs Quantity 1 // every 6 weeks (2 servings per day)
  8lbs Quantity 1 // every 24 weeks 
  8lbs Quantity 1 // every 12 weeks (2 servings per day)

  1mo: 1241153671
  2mo: 1241186439
  3mo: 1241219207
  4wk: 3022454919
  6wk: 3022487687
  8wk: 3022520455
  12wk: 3022553223
  24wk: 3022585991

  */

  let page_slug = window.location.pathname.split("/").filter(Boolean).pop() || "";
  let max_per_serving = 1.79;

  let product_options = [
    {
      name: "10oz",
      servings: 14,
      price: 24.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_US_Bovine_10oz_Front.png?v=1748274455&width=375",
      slug: "10-oz-collagen-peptides",
      options: [
        "2 // Delivery every 4 Weeks (1 serving per day) // 3022454919"
      ]
    },
    {
      name: "16oz",
      servings: 22,
      price: 29.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_render_US_Bovine16oz_Front.png?v=1748273057&width=375",
      slug: "16oz-collagen-peptides",
      options: [
        "2 // Delivery every 6 Weeks (1 serving per day) // 3022487687"
      ]
    },
    {
      name: "32oz",
      servings: 45,
      price: 52.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/32oz_Collagen_Peptides_Front.png?v=1747784421&width=375",
      slug: "32oz-collagen-peptides",
      options: [
        "1 // Delivery every 6 Weeks (1 serving per day) // 3022487687"
      ]
    },
    {
      name: "4lb",
      servings: 90,
      price: 99.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/4lb-Unflavored-Bovine_Front_4b105bc6-6eb5-4d74-9238-3ed87c5143d4.png?v=1748279014&width=375",
      slug: "4lb-collagen-peptides-bag",
      options: [
        "1 // Delivery every 12 Weeks (1 serving per day) // 3022553223",
        "1 // Delivery every 6 Weeks (2 servings per day) // 3022487687"
      ]
    },
    {
      name: "8lb",
      servings: 181,
      price: 169.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW-Unflavored-8lb-Rendering-Front.png?v=1748273229&width=375",
      slug: "8lb-collagen-peptides",
      options: [
        "1 // Delivery every 24 Weeks (1 serving per day) // 3022585991",
        "1 // Delivery every 12 Weeks (2 servings per day) // 3022553223"
      ]
    },
    {
      name: "20 sticks",
      servings: 20,
      price: 29.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_render_US_Bovine_BoxStick.png?v=1748274887&width=375",
      slug: "20ct-collagen-peptides-stick-pack",
      options: []
    }
  ];

  let selected_product;
  let page_targeted = false;

  for(let i = 0; i < product_options.length; i++){
    if(page_slug == product_options[i].slug){
      selected_product = product_options[i];
      page_targeted = true;
      break;
    }
  }

  if(page_targeted && selected_product.options.length > 0){

    let selected_plan_qty = parseInt(selected_product.options[0].split(" // ")[0]);

    let otp_full_price = `$${(max_per_serving * selected_product.servings).toFixed(2)}`;
    let otp_sale_price = `$${(selected_product.price).toFixed(2)}`;
    let otp_savings_amount = `$${(max_per_serving * selected_product.servings - selected_product.price).toFixed(2)}`;
    let sub_full_price = `$${(max_per_serving * selected_product.servings).toFixed(2)}`;
    let sub_sale_price = `$${((selected_product.price) * .85).toFixed(2)}`;
    let sub_savings_amount = `$${(max_per_serving * selected_product.servings - (selected_product.price * .85)).toFixed(2)}`;

    if(page_slug.indexOf("10-oz") > -1){
      otp_full_price = "";
      sub_full_price = `$${(selected_product.price * 2).toFixed(2)}`;
      sub_sale_price = `$${((selected_product.price * .85) * 2).toFixed(2)}`;
      sub_savings_amount = `$${((selected_product.price - (selected_product.price * .85)) * 2).toFixed(2)}`;
    }

    if(page_slug.indexOf("16oz") > -1){
      sub_full_price = `$${(max_per_serving * selected_product.servings * 2).toFixed(2)}`;
      sub_sale_price = `$${((selected_product.price * .85) * 2).toFixed(2)}`;
      sub_savings_amount = `$${((max_per_serving * selected_product.servings - (selected_product.price * .85)) * 2).toFixed(2)}`;
    }

    let options_html = "";
    for(let i = 0; i < product_options.length; i++){
      
      let is_out_of_stock = product_options[i].name == "20 sticks" ? "out-of-stock" : "";
      let is_current = product_options[i] == selected_product ? "current" : "";

      let img_html = `<img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" />`;
      if(product_options[i].name == "10oz" || product_options[i].name == "16oz"){
        img_html = `
          <img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" style="left: -20px;" />
          <img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" style="left: 20px;" />
        `;
      }

      options_html += `
      <li class="product-sibling-item size--${product_options[i].name.replace(" ", "")}">
        <a href="/products/${product_options[i].slug}" class="unstyled-link sibling-product-card ${is_current} ${is_out_of_stock}">

          <div class="card-media media-square">
            <div class="media">
              ${img_html}
            </div>
          </div>
          <span class="variant-name label paragraph-sm bold">${product_options[i].name}</span><span class="variant-name paragraph-sm" style="font-size: 10px; margin-top: -24px;">
            <span class="js-show--otp" style="font-size: inherit;">${product_options[i].servings}</span>
            <span class="js-show--sub" class="js-show--otp" style="font-size: inherit;">${parseInt(product_options[i].servings) * 2}</span> 
          Servings</span>
          <span class="variant-name paragraph-sm js-per-serving--otp">
            $${(product_options[i].price / product_options[i].servings).toFixed(2)} each
          </span>
          <span class="variant-name paragraph-sm js-per-serving--sub">
            $${((product_options[i].price / product_options[i].servings) * 0.85).toFixed(2)} each
          </span>
        </a>
      </li>
      `;
    }

    let delivery_options_html = "";
    for(let i = 0; i < selected_product.options.length; i++){

      let plan_qty = selected_product.options[i].split(" // ")[0];
      let plan_label = selected_product.options[i].split(" // ")[1];
      let plan_id = selected_product.options[i].split(" // ")[2];

      let is_selected = i == 0 ? "selected" : "";

      delivery_options_html += `
      <option ${is_selected} value="${plan_id}:${plan_qty}">
        ${plan_label}
      </option>
      `;
    }

    waitForElement('.skio-plan-picker').then(pdp_atc => {

      pdp_atc.insertAdjacentHTML("beforebegin", `

        <style>
          [class*="js-per-serving--"]{
            font-size: 9px; 
            margin-top: -24px; 
            margin-bottom: -5px;
          }

          .product-siblings{
            padding: 12px 12px 10px 12px;
            border: 1px solid var(--color-border);
            border-radius: 4px;
            margin-bottom: 16px;
            opacity: 0.8;
            cursor: pointer;
          }

          .product-siblings.is-selected{
            padding: 12px 12px;
            border: 2px solid #114734;
            border-radius: 4px;
            margin-top: 16px;
          }

          .product-siblings:not(.is-selected) .product-option-heading{
            margin-bottom: 0;
          }

          .product-siblings:not(.is-selected) circle.skio-radio,
          .product-siblings:not(.is-selected) .product-servings.product-savings,
          .product-siblings:not(.is-selected) .product-siblings-overflow,
          .js-options--sub .js-per-serving--otp,
          .js-options--otp .js-per-serving--sub, 
          [data-slug="10-oz-collagen-peptides"] .js-otp .product-savings,
          .js-options--otp .product-sibling-item .media img:nth-child(2),
          pdp-price,
          product-info > .product-siblings, 
          .skio-plan-picker .product-option-heading,
          .skio-plan-picker skio-plan-picker,
          .product-buy-buttons .quantity-input-form,
          .js-options--otp .js-show--sub,
          .js-options--sub .product-sibling-item:not(.size--10oz, .size--16oz) .js-show--sub,
          .js-options--sub .product-sibling-item.size--10oz .js-show--otp,
          .js-options--sub .product-sibling-item.size--16oz .js-show--otp
          {
            display: none;
          }

          .js-options--sub .product-sibling-item.size--10oz span.variant-name.label:after,
          .js-options--sub .product-sibling-item.size--16oz span.variant-name.label:after{
            content: " x 2";
          }

          .js-options--otp .product-sibling-item.size--10oz .media img,
          .js-options--otp .product-sibling-item.size--16oz .media img{
            left: 0 !important;
          }

      .product-sibling-item.thirty-two a:after,
      .product-sibling-item.size--32oz a:after {
          content:"Most Popular";
          background: #114734;
          color: white;
          position: absolute;
          text-align: center;
          top: -8px;
          right: 5px;
          width: calc(100% - 10px);
          padding: 2px 10px 0 10px;
          font-size: 8px;
          line-height: 2;
          border-radius: 4px;
          font-weight: var(--font-weight-extra-bold);
          font-family: var(--font-family-base);
      }
      .product-sibling-item.eight-pound a:after,
      .product-sibling-item.size--8lb a:after {
          content:"Best Value";
          background: white;
          color: #114734;
          position: absolute;
          text-align: center;
          top: -8px;
          right: 5px;
          width: calc(100% - 10px);
          padding: 2px 10px 0 10px;
          font-size: 8px;
          line-height: 1.5;
          border-radius: 4px;
          font-weight: var(--font-weight-extra-bold);
          font-family: var(--font-family-base);
          border: 1px solid #114734
      }
      .product-siblings {
          overflow: hidden;
      }

      span[id*="sale-price"]{
        font-weight: 800;
      }

      @media screen and (max-width: 1280px) {
        .product-siblings-overflow .product-sibling-item .variant-name {
            line-height: 1.5;
        }
      }

      @media screen and (max-width: 768px) {
          [class*="js-per-serving--"]{
            margin-bottom: 5px !important;
          }

          .sibling-product-card {
              padding-bottom: 0!important;
          }
          .sibling-product-card .variant-name.paragraph-sm:nth-of-type(2) {
              margin-top: -18px!important;
              margin-bottom: 20px;
          }
          .product-sibling-item {
              width: 120px!important;
          }
      }
      </style>

      <div class="js-purchase-options" data-slug="${page_slug}">

        <div class="product-siblings js-otp">
          <div class="skio-radio__container" style="position: absolute; margin-top: -2px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
              <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
            </svg>
          </div>
          <div class="product-option-heading">
            <h2 class="subtitle-sm" style="margin-left: 30px;">One-Time Size Options</h2>
            <p class="product-servings paragraph-sm" style="font-weight: 800;">
              <span style="text-decoration: line-through; font-size: 75%;" id="js-otp-full-price">${otp_full_price}</span> 
              <span id="js-otp-sale-price">${otp_sale_price}</span>
            </p>
          </div>
          <p class="product-servings paragraph-sm product-savings" style="text-align: right; margin-top: -18px; font-size: 75%; margin-bottom: 18px;">
            You Save <span id="js-otp-savings-amount">${otp_savings_amount}</span>!
          </p>
          <ul class="product-siblings-overflow list-unstyled js-options--otp" style="position: relative;">
            ${options_html}
          </ul>
        </div>

        <div class="product-siblings js-subs">
          <div class="skio-radio__container" style="position: absolute; margin-top: -2px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
              <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
            </svg>
          </div>
          <div class="product-option-heading">
            <h2 class="subtitle-sm" style="margin-left: 30px;">Auto Delivery Options</h2>

            <p class="product-servings paragraph-sm" style="font-weight: 800;">
            <span style="text-decoration: line-through; font-size: 75%;" id="js-subs-full-price">${sub_full_price}</span> 
            <span id="js-subs-sale-price">${sub_sale_price}</span></p>
          </div>
          <p class="product-servings product-savings paragraph-sm" style="text-align: right; margin-top: -18px; font-size: 75%; margin-bottom: 18px;">You Save <span id="js-subs-savings-amount">${sub_savings_amount}</span>!</p>
          <ul class="product-siblings-overflow list-unstyled js-options--sub" style="position: relative;">
            ${options_html}
          </ul>
          
          <select class="selling-plan-dropdown"
            style="width: 100%; font-size: 12px; background: white; border: 1px solid #114734; padding: 10px 10px 8px 10px; margin-top: 12px; border-radius: 2px; background-image: url(&quot;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false' role='presentation' viewBox='0 0 24 24' fill='none'%3E%3Cpath stroke-width='0' fill='%23114734' d='M21.4,6.6l-9.4,6.6L2.6,6.6l-.6.9,8.5,8.9c.7.8,1.1,1,1.5,1s.8-.3,1.5-1l8.5-8.9-.6-.9Z'/%3E%3C/svg%3E&quot;); background-repeat: no-repeat; background-position: calc(100% - 6px); background-size: 20px;">
            
            ${delivery_options_html}
            
          </select>
        </div>
        
      </div>
      `);

      waitForElement('skio-plan-picker').then(plan_picker => {

          waitUntil(() => {

            return !!(
              plan_picker.shadowRoot &&
              plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown') &&
              plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options.length > 0
            );

          }).then(() => {

            let subs = plan_picker.shadowRoot.querySelector('[id*="group-0-skio_plan_picker_"]')
            let otp = plan_picker.shadowRoot.querySelector('[id*="one-time-skio_plan_"]')
            waitForElement('input.quantity-input[name="quantity"]').then(qty => {
              waitForElement('.js-purchase-options .js-otp').then(js_otp => {
                waitForElement('.js-purchase-options .js-subs').then(js_subs => {

                  js_otp.addEventListener("click", () => {
                    
                    js_otp.classList.add("is-selected");
                    otp.checked = true;
                    otp.dispatchEvent(new Event('change', { bubbles: true }));
                    
                    js_subs.classList.remove("is-selected");

                    qty.value = 1;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));

                  });
                  js_subs.addEventListener("click", () => {
                    js_otp.classList.remove("is-selected");
                    
                    js_subs.classList.add("is-selected");
                    subs.checked = true;
                    subs.dispatchEvent(new Event('change', { bubbles: true }));

                    qty.value = selected_plan_qty;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));

                  });

                  // init
                  if(otp.checked){
                    js_otp.classList.add("is-selected");
                  } else {
                    js_subs.classList.add("is-selected");
                    qty.value = selected_plan_qty;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));
                  }

                }).catch();
              }).catch();
            }).catch();

            // prepare options
            let selling_plans = plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown');
            let selling_plans_options = selling_plans.options;
            let selected_option_default_plan = selected_product.options[0].split(" // ")[2];
            for(let i = 0; i < selling_plans_options.length; i++){

              selling_plans_options[i].hidden = false;
              if(selling_plans_options[i].value == selected_option_default_plan){ 
                selling_plans_options[i].selected = true;
                selling_plans.dispatchEvent(new Event('change', { bubbles: true }))
              }

            }

            waitForElement('.js-subs .selling-plan-dropdown').then(delivery_options => {
              delivery_options.addEventListener("change", (e) => {

                let selected_plan_id = e.target.value.split(":")[0];
                // let selected_plan_qty = e.target.value.split(":")[1];

                for(let i = 0; i < selling_plans_options.length; i++){
                  if(selling_plans_options[i].value == selected_plan_id){ 
                    selling_plans_options[i].selected = true;
                    selling_plans.dispatchEvent(new Event('change', { bubbles: true }))
                  }
                }
                
              });
            }).catch();

          }).catch();

      }).catch();

    }).catch();

  } // page_targeted
} // if(window.sessionStorage.getItem("GLW-02") == "v1")

//
// [GLW-03]
//

let activation_param = "pt=freegift";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                  source: "email signup",
                  _discount: "email signup"
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
        console.log('Added to cart:', data);
        waitForElement('input[data-quantity-variant-id]').then(qty_input => {
            qty_input.dispatchEvent(new Event('change', { bubbles: true }));
        }).catch();
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[GLW-03] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
    window.sessionStorage.setItem("[GLW-03] in-cart treatment", true);

    waitUntil(() => {
        return document.querySelectorAll('cart-drawer-items table.cart-items .cart-item-details').length > 0;
    }).then(() => {

        let review_cart = () => {

            let cart_items = document.querySelectorAll('cart-drawer-items table.cart-items tr.cart-item');
            let show_gwp = false;
            for(let i = 0; i < cart_items.length; i++){
                if(cart_items.length > 0){
                    show_gwp = true;
                }
                if(cart_items[i].innerText.indexOf("source: email signup") > -1){
                    show_gwp = false;
                    break;
                }
            }

            if(show_gwp){
                // an item is in the cart AND not the offer
                console.log("setting it up")
                
                if(document.querySelectorAll('.drawer-cart-items-wrapper .js-offer').length == 0){
                    document.querySelector('.drawer-cart-items-wrapper').insertAdjacentHTML("afterbegin", `
                        <style>
                        .js-offer{
                            background: #f9f0e2 url(https://greatlakeswellness.com/cdn/shop/files/1x1_VarietyStickPack_6ct_FOP-2.png?v=1750950904&width=300) no-repeat;
                            background-size: 100px;
                            background-position: 10px -10px;
                            margin: 1rem 0;
                            padding: 1rem;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        }
                        
                        .js-offer > div:first-child{
                            padding-left: 100px;
                        }
                        .js-offer > div:last-child{
                            text-align: center;
                        }
                        .js-offer > div span{
                            display: block;
                            font-size: .75rem;
                        }
                        .js-offer > div:last-child span{
                            margin-top: -.5rem;
                        }
                        .js-offer #gwp-atc{
                            transform: scale(.75)
                        }
                        @media(max-width: 525px){
                            .js-offer{
                                display: block;
                            }
                            .js-offer > div:last-child{
                                text-align: left;
                                margin-left: 75px;
                            }        
                            .js-offer #gwp-atc{
                                margin-left: 0;
                            }   
                            .js-offer > div:last-child span{
                                margin-left: 55px;
                            }
                        }

                        </style>
                        <div class="js-offer">
                            <div>
                                Claim your <strong>FREE</strong> Collagen Peptide Variety Pack
                                <div><span>For Orders Over $40</span></div>
                            </div>
                            <div>
                                <div id="gwp-atc" class="cart-checkout-button btn-primary">Add to Cart</div>
                                <span>a $11.99 value</span>
                            </div>
                            
                        </div>
                    `)
                }
            } else {
                console.log("tearing it down")
                if(document.querySelectorAll('.js-offer') > 0){
                    document.querySelector('.js-offer').remove();
                }
            }

        } // review_cart();

        // init
        setTimeout(() => {
            review_cart();
        }, 1500)

        observeSelector('cart-drawer-items table.cart-items tr.cart-item', line_item => {
            review_cart();
            console.log();
        });

        observeSelector('#gwp-atc', gwp_atc => {
            gwp_atc.addEventListener("click", (e) => {
                add_item_to_cart(42809688064135); // 6ct Flavored Collagen Peptide Variety Pack
                gwp_atc.parentNode.style.opacity = 0.5;
                setTimeout(() => {
                    gwp_atc.parentNode.remove();
                }, 750)
            });
        });


    }).catch();

}

//
//
//
//
//

/* 

This module does a lot. It should be one-size-fits-most. With some setup, mostly defining css_selectors and some style tweaks

here are the main features:
- leverages (or creates) the cart:change event to update the cart_data object
- refreshes at adjustments to the cart object
- is injected into the cart
- supports proteus custom discounting logic
- offers GWP ATC functionality (in-cart)
- [in-progress] support for freeshipping messaging
- is embeddable anywhere via <div class="js-incentives--container"></div>

*/

/* 

// ASSETS: these could live anywhere

*/

const svg_gift = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
 <path d="m692.39 1141.3h339.32c5.4844 0 9.9375-4.4531 9.9375-9.9375v-537.74h-349.26z"/>
 <path d="m547.6 563.06v578.26h114.28v-770.58h-114.28z"/>
 <path d="m102.09 380.68v172.45c0 5.4844 4.4531 9.9375 9.9375 9.9375h405.05l-0.046875-192.32h-405c-5.4844 0-9.9375 4.4531-9.9375 9.9375z"/>
 <path d="m167.81 1131.4c0 5.4844 4.4531 9.9375 9.9375 9.9375h339.32l-0.046874-547.69h-349.22z"/>
 <path d="m1097.6 370.74h-405.19v192.32h405.19c5.4844 0 9.9375-4.4531 9.9375-9.9375v-172.45c0-5.4844-4.4531-9.9375-9.9375-9.9375z"/>
 <path d="m529.82 317.26c-1.2188-0.375-124.64-36.375-180.74-72.469-10.5-6.75-14.438-20.203-8.6719-31.266 13.406-24.938 24.141-38.438 24.75-39.281 0.65625-0.98438 16.266-24.328 44.906-6.6562 21.891 13.547 46.688 28.875 142.03 123.47l32.25 32.016-17.766-41.812c-90.375-213.14-145.82-216.98-186.37-219.79-39.047-2.6719-77.766 36.562-79.453 38.344-3.75 3.8906-91.547 96.516-46.031 169.31 39.234 62.766 232.26 65.672 267.52 65.672h5.25l60.141-0.75z"/>
 <path d="m954.74 269.11c45.516-72.797-42.234-165.37-46.078-169.36-1.6406-1.6875-40.688-41.25-79.406-38.25-40.5 2.8125-96 6.6094-186.37 219.79l-17.719 41.812 32.25-32.016c95.344-94.641 120.14-109.97 142.4-123.74 27.422-16.922 42.844 4.4531 45 7.5938 0.09375 0.14062 10.828 13.641 24.562 39.188 5.4375 10.453 1.4531 23.906-9 30.656-56.109 36.094-179.48 72.094-180.74 72.469l-57.797 16.781 60.141 0.75h5.25c35.297-0.046875 228.28-2.9531 267.52-65.672z"/>
</svg>`;

const svg_savings = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
 <path d="m816.28 82.359-82.078 195.89c-6.4688-1.8281-12.938-2.7656-20.062-2.7656h-228.61c-7.0781 0-13.594 0.9375-20.062 2.7656l-82.078-195.89c-4.0312-9.8906 6.4688-19.125 16.031-14.203l23.438 12.328c15.422 8.3438 33.609 8.3438 48.75 0l27.469-14.484c15.422-8.0156 33.609-8.0156 48.75 0l27.469 14.484c15.422 8.3438 33.609 8.3438 49.078 0l27.141-14.203c15.141-8.3438 33.328-8.3438 48.75-0.32812l27.469 14.812c15.422 8.0156 33.609 8.0156 49.078 0l23.766-12.656c9.2344-5.1562 19.688 4.4062 15.703 14.25zm-122.48 268.08h10.172l0.32812-0.60938c-3.4219 0.60938-6.7969 0.60938-10.5 0.60938zm20.953 789.56h-229.5c-183.89 0-319.31-90.703-297.42-302.06 16.641-160.45 99.656-350.16 241.26-438.1 13.875 15.422 34.266 25.312 56.484 25.312h228.61c22.547 0 42.562-9.8906 56.484-25.594 141.94 87.938 224.9 277.97 241.6 438.42 21.844 211.31-113.62 302.02-297.52 302.02zm-198.37-454.45c6.1875-40.406 52.734-52.453 76.5-53.062 17.297-0.9375 74.953 0.9375 90.375 44.719 1.2188 3.7031 2.1562 7.7344 2.4844 11.719 0.9375 8.625 8.9531 14.484 16.969 13.875 8.3438-0.60938 14.484-8.0156 13.875-16.641-0.60938-6.7969-2.1562-13.266-4.3125-19.453-12.938-37.031-48.422-60.141-96.891-64.5v-56.156c0-8.625-7.0781-15.422-15.422-15.422-8.625 0-15.422 6.7969-15.422 15.422v56.156c-43.5 4.0312-91.031 29.016-98.719 78.375-3.7031 24.984 3.375 49.688 20.062 70.031 21.281 25.312 54.609 40.125 93.469 41.016 29.906 0.9375 55.547 12.047 70.641 30.234 11.109 13.266 16.031 29.297 13.594 45.375-6.4688 40.125-53.062 52.453-76.828 53.062-17.297 0.60938-74.672-0.9375-90.094-44.719-1.5469-3.7031-2.4844-7.7344-2.7656-11.719-0.60938-8.625-8.0156-14.484-16.641-14.203-8.625 0.9375-14.812 8.3438-13.875 16.969 0.60938 6.4688 1.8281 13.266 4.0312 19.453 13.266 37.031 48.75 60.141 97.172 64.5v56.484c0 8.3438 6.7969 15.422 15.422 15.422 8.3438 0 15.422-7.0781 15.422-15.422v-56.484c43.5-4.0312 91.031-29.016 98.438-78.656 4.0312-24.703-3.0938-49.688-20.062-69.75-21-25.312-54.281-40.125-93.469-41.344-29.625-0.60938-55.547-11.719-70.641-29.906-11.156-13.312-15.75-29.625-13.312-45.375zm241.92-335.16c0-24.328-19.688-44.016-44.016-44.016h-228.71c-24.328 0-44.016 19.688-44.016 44.016s19.688 44.016 44.016 44.016h228.71c24.281 0 44.016-19.688 44.016-44.016z"/>
</svg>`;

const svg_shipping = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="225 225 750 750" xmlns="http://www.w3.org/2000/svg">
 <path d="m978 613.69c-0.09375-16.5-4.6406-32.672-13.219-46.828l-72.703-111.38v0.046875c-12.469-15.141-31.031-23.859-50.625-23.766h-103.45v-65.531c-0.046875-9.9375-8.0625-17.953-18-18h-384c-4.7812 0-9.375 1.875-12.75 5.25s-5.25 7.9688-5.25 12.75v47.531h-78c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h147.14c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-69.141v29.531h-78c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h180c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-102v29.484h-45.375c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h114.52c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-69.141v84.984c0.046875 9.8906 8.1094 17.906 18 18h56.625c8.3438 35.156 39.703 60 75.844 60s67.547-24.844 75.844-60h195.84c8.2969 35.156 39.703 60 75.844 60s67.547-24.844 75.844-60h68.156c9.8906-0.09375 17.953-8.1094 18-18zm-509.53 202.08c-16.969 0-32.297-10.219-38.812-25.922-6.4688-15.703-2.9062-33.75 9.1406-45.797 12-12 30.047-15.609 45.75-9.0938s25.922 21.797 25.922 38.812c-0.09375 23.156-18.844 41.906-42 42zm347.53 0c-16.969 0-32.297-10.219-38.812-25.922-6.4688-15.703-2.9062-33.75 9.0938-45.797 12.047-12 30.094-15.609 45.797-9.0938s25.922 21.797 25.922 38.812c-0.046875 23.203-18.797 41.953-42 42zm-78.234-240 0.23438-108h103.45c8.2031-0.14062 16.125 3.1875 21.844 9.0938l64.547 98.859z"/>
</svg>`

/*

// SETTINGS: probably best defined on theme.liquid (OR re-scoped proteus-utils.js eventually)
// at a minimum, this much liquid-generated JS needs to exist:

window.cart_data = {{ cart | json }};
{% assign gwp_product = all_products["modern-matcha-starter-set"] %}
window.gwp_product = {
  {% if gwp_product.available %}
    var_id: {{ gwp_product.selected_or_first_available_variant.id }},
    var_title: "{{ gwp_product.title }}",
    var_subtitle: "For Orders Over $100",
    var_value: "{{ gwp_product.price | money }}",
    var_img: "{{ gwp_product.images[0] | img_url: '600x' }}",
  {% endif %}
}

// then these values are custom per environment and need to be defined at setup + go through QA

*/

let bfcm_2025_live = true;

window.cart_css_selector = 'cart-drawer'; // observed for changes
window.cart_header_css_selector = 'cart-drawer .drawer-header'; // where bar is injected by default
window.cart_items_css_selector = 'cart-drawer-items'; // where GWP is injected
window.original_shipping_bar_css_selector = '.js-shipping-progress';

let free_shipping_threshold = 6000; // or subscription product
let gwp_source_prop = "BFCM"; // this will show in-cart as "source: [gwp_source_prop]"
let gwp_discount_prop = "BFCM 2025"; // this will not show in-cart but is used to activate discount

let incentives_thresholds = [
  {
    amount: 5000,
    label: "15% off",
    message: "Get 15% off",
    threshold_icon: svg_savings,
    gwp_product: {},
    gwp_product_subtitle: "",
  },
  {
    amount: 10000, 
    label: "20% off<br>+<br>Free Gift",
    message: "Get 20% off + Free Gift",
    threshold_icon: svg_gift,
    gwp_product: window.gwp_product_1,
    gwp_product_subtitle: "Free for all orders $100+",
  },
  {
    amount: 15000, 
    label: "25% off<br>+<br>Free Gift",
    message: "Get 25% off + Free Gift",
    threshold_icon: svg_gift,
    gwp_product: window.gwp_product_1,
    gwp_product_subtitle: "Free for all orders $100+",
  },
];

// we use cart:change to update the cart_data object (see example)

///////////////////////////////
// using cart:change (example)
///////////////////////////////

/*
document.addEventListener("cart:change", (event) => {
  console.log("change data", event);
});
*/

// cart:change is not always available. if it is, great (this is most-performant)
// otherwise we need to set it up

// sometimes it CAN be added into the theme.js's API calls, okay... but be careful (see example)

///////////////////////////////
// adding cart:change (example)
///////////////////////////////

/* 
fetch("/cart/add.js", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ items: [{ id: var_id, quantity: 1 }] }),
}).then(res => res.json()).then(cart => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:change", { detail: { cart } })
  );
});
*/

// we want a one-size-fits-all option. if cart:change is not available this method doesn't cause a lot of noise or traffic
// polling for DOM for changes, every 5s check the cart and get the data if updated -- (stable, low-impact, kinda slow)

async function update_cart_data() {
  try {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error("Failed to fetch cart");
    const cart = await res.json();

    window.cart_data = cart;
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", { 
        detail: { cart },
        bubbles: true
      })
    );

    return cart;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
}

waitForElement(window.cart_css_selector).then(cart => {

  let current_state = cart.innerText.toLowerCase();
  setInterval(() => {
    if(document.querySelector(window.cart_css_selector).innerText.toLowerCase() != current_state){
      // console.log("cart updated -- get data");
      update_cart_data();
      // set new current state
      current_state = document.querySelector(window.cart_css_selector).innerText.toLowerCase();
    }
  }, 2000); // 2s

}).catch();

//
// START -- [GLW-BFCM] 2025
//

/*

NOTE: make sure [GLW-04] is ended (it conflicts with the treatment)
QA: ?qa=GLW-04&v=Control&bfcm2025=active

Treatment:
◦ 15% off $50
◦ 20% off $100 + Free 6ct Variety Pack
◦ 25% off $150 + Free 12ct Variety Pack
◦ We’ll kick off with the gifts “while supplies last” knowing that we will sell through inventory during the week of 11/24.
◦ When gifts are gone, we fall back to 15/20/25% price tiers until EOD 11/30.
◦ Free Shipping remains at $60+ or free with subscription for the duration


*/

// get var_ids to exclude from total
const gwp_var_ids = [...new Set(
  incentives_thresholds
    .filter(tier => tier.gwp_product && tier.gwp_product.var_id)
    .map(tier => tier.gwp_product.var_id)
)];

if(window.location.href.indexOf("bfcm2025=active") > -1 || bfcm_2025_live){
  document.addEventListener("DOMContentLoaded", () => {
    console.log("init - BFCM 2025")
    gtm_add_cartAttribute("_discount", "BFCM 2025");
  })
}

// GWP: (claim item, custom discount)
// discount applied
// free shipping 

if(window.sessionStorage.getItem("[GLW-BFCM] 2025 active") || window.location.href.indexOf("bfcm2025=active") > -1 || bfcm_2025_live){
  window.sessionStorage.setItem("[GLW-BFCM] 2025 active", true);

  // inject styles
  waitForElement('body').then(doc => {

    doc.insertAdjacentHTML('afterbegin', `
      <style>
      ${window.original_shipping_bar_css_selector}{
        display: none !important;
      }
      .js-incentives--threshold{
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1em;
        font-size: 1.5em;
        padding: 3px;
        position: absolute;
        bottom: .5rem;
        left: 0;
        text-align: center;
        width: 1.5rem;
        height: 1.5rem;
        border: 1px solid;
        border-radius: 100%;
        background: #f5f5f5;
      }

      .js-incentives--threshold svg path{
        fill: #114734 !important;
      }
        
      .js-incentives--threshold.js-met{
        background: #114734;
      }

      .js-incentives--threshold.js-met svg path{
        fill: #fff !important;
      }

      .js-incentives--threshold span{
        font-size: 11px;
        position: absolute;
        top: 1.75rem;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        line-height: .75em;
      }

      .js-incentives--threshold:last-child span{
        left: auto;
        right: 0;
        transform: none;
        width: 60px;
      }
      
      .js-incentives {
        position: relative;
        padding: 15px 0;
        margin: 10px 0 2rem 0;
      }
      .js-incentives--message {
        text-align: center;
        font-size: .95em;
        margin-bottom: 10px;
        font-weight: 400;
        color: #114734;
      }
      .js-incentives--bar {
        border: 1px solid #114734;
        border-radius: 10px;
        overflow: hidden;
        height: 10px;
        background: #f5f5f5;
      }
      .js-incentives--fill {
        background: #114734;
        height: 100%;
        transition: width 0.3s ease;
        min-width: 1px;
      }
      </style>
    `);

  }).catch();

  let update_incentives_bar = () => {
    // console.log('update_incentives_bar()');

    let total_gwp_cost = cart_data.items.reduce((sum, item) => {
      if (gwp_var_ids.includes(item.id)) {
        return sum + (item.price * item.quantity);
      }
      return sum;
    }, 0);

    // let cart_total = cart_data.total_price;
    let cart_total = cart_data.original_total_price - total_gwp_cost;
    console.log("doing the check...", cart_data.original_total_price, total_gwp_cost, gwp_var_ids);

    let incentives_thresholds_html = ``;
    for(let i = 0; i < incentives_thresholds.length; i++){
      incentives_thresholds_html += `
        <div class="js-incentives--threshold ${incentives_thresholds[i].amount <= cart_total ? 'js-met' : ''}" data-amount="${incentives_thresholds[i].amount}" 
        style="left: calc(${((i + 1) / incentives_thresholds.length)*100}% - 1rem);">${incentives_thresholds[i].threshold_icon}
          <span>${incentives_thresholds[i].label}</span>
        </div>
      `;
    }

    let js_incentives_html = `
      <div class="js-incentives">
        <div class="js-incentives--message"></div>
        <div class="js-incentives--bar">
          <div class="js-incentives--fill">&nbsp;</div>
        </div>
        ${incentives_thresholds_html}
      </div>
    `;
    
    if(document.querySelectorAll(`${window.cart_css_selector} .js-incentives`).length == 0){
      // build .js-incentives in DOM
      waitForElement(`${window.cart_css_selector} .drawer-header`).then(drawer_header => {
        drawer_header.insertAdjacentHTML('afterend', js_incentives_html);
      }).catch();
    }

    // update embedded_incentives
    let embedded_incentives = document.querySelectorAll('.js-incentives--container')
    for(let i = 0; i < embedded_incentives.length; i++){
      if(embedded_incentives[i].querySelectorAll(".js-incentives").length == 0){
        embedded_incentives[i].innerHTML = js_incentives_html;
      }
    }

    observeSelector('.js-incentives', js_incentives => {

      let bar_fill = js_incentives.querySelector('.js-incentives--fill');
      let progress_message = js_incentives.querySelector('.js-incentives--message');
      let max_met_threshold = -1;
      
      // Update UI
      let thresholds = js_incentives.querySelectorAll('.js-incentives--threshold');
      for(let i = 0; i < incentives_thresholds.length; i++){

        if(cart_total >= incentives_thresholds[i].amount){
          thresholds[i].classList.add("js-met");
          max_met_threshold = i;
        } else {
          thresholds[i].classList.remove("js-met");
        }
        
        if(incentives_thresholds[i].amount >= cart_total){

          if(i > 0){
            progress_message.innerHTML = `
              You ${incentives_thresholds[i - 1].message}.<br>Spend <strong>$${((incentives_thresholds[i].amount - cart_total) / 100).toFixed(2)}</strong> more and ${incentives_thresholds[i].message}
            `;
          } else {
            progress_message.innerHTML = `
              Spend <strong>$${((incentives_thresholds[i].amount - cart_total) / 100).toFixed(2)}</strong> more and ${incentives_thresholds[i].message}
            `;
          }
          break;

        } else if(i == incentives_thresholds.length - 1){
          progress_message.innerHTML = `
            You ${incentives_thresholds[incentives_thresholds.length - 1].message}
          `;
        }
      }

      if(cart_total/incentives_thresholds[incentives_thresholds.length - 1].amount >= 1){
        bar_fill.style.width = "100%";
      } else {
        let active_threshold_goal = max_met_threshold >= 0 ? max_met_threshold : 0;
        let progress_to_threshold = cart_total/incentives_thresholds[active_threshold_goal].amount;
        bar_fill.style.width = `calc(${((active_threshold_goal + 1) / incentives_thresholds.length * progress_to_threshold)*100}% - .25rem)`;
      }

      if(max_met_threshold >= 0 &&
      !!incentives_thresholds[max_met_threshold].gwp_product.var_id && 
      cart_total >= incentives_thresholds[0].amount){

        if(document.querySelectorAll(`${window.cart_items_css_selector} .js-offer`).length == 0 && 
        cart_data.items.filter(item => item.properties?.source === gwp_source_prop && item.variant_id == incentives_thresholds[max_met_threshold].gwp_product.var_id).length == 0){

          document.querySelector(window.cart_items_css_selector).insertAdjacentHTML("afterbegin", `
            <div class="js-offer--container">
              <style>
              .js-offer{
                  background: #f9f0e2 url(${incentives_thresholds[max_met_threshold].gwp_product.var_img}) no-repeat;
                  background-size: 120px;
                  background-position: left center;
                  margin: 1rem 0;
                  padding: 1rem;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
              }
              
              .js-offer > div:first-child{
                  padding-left: 100px;
              }
              .js-offer > div:last-child{
                  text-align: center;
              }
              .js-offer > div span{
                  display: block;
                  font-size: .75rem;
              }
              .js-offer > div:last-child span{
                  margin-top: -.5rem;
              }
              .js-offer .js-gwp-atc{
                  transform: scale(.75)
              }
              @media(max-width: 525px){
                  .js-offer{
                      display: block;
                  }
                  .js-offer > div:last-child{
                      text-align: left;
                      margin-left: 75px;
                  }        
                  .js-offer .js-gwp-atc{
                      margin-left: 0;
                  }   
                  .js-offer > div:last-child span{
                      margin-left: 55px;
                  }
              }

              </style>
              <div class="js-offer">
                  <div>
                      Claim your <strong>FREE</strong> ${incentives_thresholds[max_met_threshold].gwp_product.var_title}
                      <div><span>${incentives_thresholds[max_met_threshold].gwp_product_subtitle}</span></div>
                  </div>
                  <div>
                      <div class="js-gwp-atc cart-checkout-button btn-primary" data-var-id="${incentives_thresholds[max_met_threshold].gwp_product.var_id}" data-prop="BFCM 2025">Add to Cart</div>
                      <span>a ${incentives_thresholds[max_met_threshold].gwp_product.var_value} value</span>
                  </div>
                  
              </div>
            </div>
          `)

          waitForElement('.js-gwp-atc').then(bfcm_atc => {

            let var_id = bfcm_atc.getAttribute("data-var-id");

            bfcm_atc.addEventListener("click", () => {

              add_gwp_item(var_id);
            
            });

          }).catch();
        }
      } else if(document.querySelectorAll('.js-offer--container').length > 0){
        document.querySelector('.js-offer--container').remove();
      }

    }); // observeSelector('.js-incentives')
    
  }

  // init
  setTimeout(() => {
    update_incentives_bar();
  }, 500)

  document.addEventListener("cart:change", (e) => {
    // console.log("its a cart change!", e.detail);
    update_incentives_bar();
  });

  observeSelector('cart-drawer .drawer-container', drawer_contents => {
    update_incentives_bar();
  })

}

async function add_gwp_item(var_id) {
  
  try {
    // find + remove any line items added from GWP
    const gwp_items = cart_data.items.filter(item => item.properties?.source === gwp_source_prop);
    for (const item of gwp_items) {
      console.log("Removing existing gwp item:", item.id);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }

    // add the gwp item
    const cart_add_gwp_item = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: var_id,
            quantity: 1,
            properties: {
              source: gwp_source_prop,
              _discount: gwp_discount_prop,
            },
          },
        ],
      }),
    });

    const data = await cart_add_gwp_item.json();
    console.log("added gwp item:", data);

    // reload cart
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external' });

  } catch (err) {
    console.error("Error updating cart:", err);
  }
}